import type { AssistantContextSummary, AssistantFilterBadge } from '@triedge/ai-assistant-ui';
import type { AdmissionsAIContext } from './types';

const statusDisplayNames: Record<string, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  under_review: 'Under Review',
  interview_scheduled: 'Interview Scheduled',
  decision_pending: 'Decision Pending',
  accepted: 'Accepted',
  accepted_pending_enrollment: 'Pending Enrollment',
  acceptance_expired: 'Expired',
  waitlisted: 'Waitlisted',
  denied: 'Denied',
  enrolled: 'Enrolled',
  withdrawn: 'Withdrawn',
};

const gradeDisplayNames: Record<string, string> = {
  nursery: 'Nursery',
  pre_k: 'Pre-K',
  kindergarten: 'Kindergarten',
  grade_1: 'Grade 1',
  grade_2: 'Grade 2',
  grade_3: 'Grade 3',
  grade_4: 'Grade 4',
  grade_5: 'Grade 5',
  grade_6: 'Grade 6',
  grade_7: 'Grade 7',
  grade_8: 'Grade 8',
};

const pushLimitedBadges = (
  list: AssistantFilterBadge[],
  values: string[],
  color: string,
  mapper?: (value: string) => string
) => {
  const display = values.slice(0, 2).map((value) => ({
    label: mapper ? mapper(value) : value,
    color,
    variant: 'light' as const,
  }));
  list.push(...display);
  if (values.length > 2) {
    list.push({
      label: `+${values.length - 2} more`,
      color,
      variant: 'light',
    });
  }
};

export const buildAdmissionsContextSummary = (
  context: AdmissionsAIContext,
  resultCount: number,
  entityLabel?: string
): AssistantContextSummary => {
  const filters: AssistantFilterBadge[] = [];

  if (context.status?.length) {
    pushLimitedBadges(filters, context.status, 'gray', (status) => statusDisplayNames[status] || status);
  }

  if (context.grade?.length) {
    pushLimitedBadges(filters, context.grade, 'blue', (grade) => gradeDisplayNames[grade] || grade);
  }

  if (context.assignedTo) {
    filters.push({ label: 'Assigned', color: 'teal', variant: 'light' });
  }

  return {
    count: resultCount,
    label: entityLabel,
    searchLabel: context.search,
    filters,
  };
};
